import React, { useRef, useState } from 'react';
import * as mobxReact from 'mobx-react';
import classnames from 'classnames';
import Text from '../../../../../../global/text/text';
import ChevronSVG from '../../../../../../../images/svg/icons8-expand-arrow';
import './send-connection-email-header.scss';
import { EmailTemplatesListDropdown } from '../../email-templates-dropdown/email-templates-dropdown';
import { SendConnectionsEmailFormViewmodel } from '../send-connections-email-form.viewmodel';

export interface ISendConnectionsEmailFormHeaderProps {
    vm: SendConnectionsEmailFormViewmodel;
}

export const SendConnectionsEmailFormHeader = mobxReact.observer((({
    vm
}: ISendConnectionsEmailFormHeaderProps) => {
    const [isStatusModalOpen, setStatusModalOpen] = useState(false);
    const statusButtonRef = useRef(null);

    return (
        <div className='oe-popup-layout__header send-emails-template-form-layout'>
            <div className='send-emails-template-form-header'>
                <div className='send-emails-template-form-header__item'>
                    <div
                        className={classnames('send-emails-template-form-header__dropdown')}
                        ref={statusButtonRef}
                    >
                        <div className='send-emails-template-form-header__wrapper' onClick={() => setStatusModalOpen(true)}>
                            <div className='send-emails-template-form-header__team'>
                                <Text
                                    message={`Template: ${vm.selectedOption?.name}`}
                                    withEllipsis
                                />
                                <ChevronSVG />
                            </div>
                        </div>
                        <EmailTemplatesListDropdown
                            emailTemplatesList={vm.emailTemplates}
                            closeEmailTemplatesDropdown={() => setStatusModalOpen(false)}
                            isOpened={isStatusModalOpen}
                            selectTemplateFromList={vm.meetingConnectionsFormVm.selectTemplateFromList}
                            selectedEmailTemplate={vm.selectedOption}
                            itemRef={statusButtonRef}
                            position='bottom'
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}));
